import React from 'react';
import { Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const { Password } = Input;

interface InputProps {
  id: string;
  placeholder: string;
}

export const PasswordInput: React.FC<InputProps> = ({ placeholder, id }) => {
  return (
    <Password
      autoComplete="new-password"
      id={id}
      placeholder={placeholder}
      size="large"
      prefix={<LockOutlined />}
    />
  );
};
